export function shouldStartScrapersConsultation({
  isDefaultFlow,
}: {
  isDefaultFlow: boolean;
  hasFinishedNormalConsultation?: boolean;
  hasNormalPassages?: boolean;
  hasChosenToSeePassages?: boolean;
}): boolean {
  return isDefaultFlow;
}
